import { Link } from 'react-router-dom';
import React from 'react';
import { formatAddress, formatCurrency } from '../../helpers';
import { useProperties } from '../../hooks';
import { env } from '../../environment';

const Footer = () => {
  const { recentProperties } = useProperties();

  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  }

  return (
    <footer id="page-footer">
      <div className="inner">
        <aside id="footer-main">
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-sm-3">
                <article>
                  <h3>About Us</h3>
                  <p>
                    For years, millions of home shoppers have turned
                    to EU International Realty® to find their dream home.
                    Find thousands of properties for sale and for rent including
                    properties for holiday let at European Property.
                  </p>
                  <hr/>
                  <Link to="/about" className="link-arrow">Read More</Link>
                </article>
              </div>
              <div className="col-md-3 col-sm-3">
                <article>
                  <h3>Recent Properties</h3>
                  {recentProperties
                    .map((property, i) => (
                      <div key={i} className="property small">
                        <Link to={'/properties/' + property.id}>
                          <div className="property-image">
                            <img src={`${env.apiUrl}/uploads/${property.image}`}
                                 style={{ height: '75px' }} alt="Property"/>
                          </div>
                        </Link>
                        <div className="info">
                          <Link to={'/properties/' + property.id}>
                            <h4>{property.street}</h4>
                          </Link>
                          <figure>{formatAddress(property)}</figure>
                          <div className="tag price">
                            {formatCurrency(property.price)}
                          </div>
                        </div>
                      </div>
                    ))}
                </article>
              </div>
              <div className="col-md-3 col-sm-3">
                <article>
                  <h3>Contact</h3>
                  <address>
                    <strong>EU International Realty</strong><br/>
                    Nelkenstraße 34, 86551<br/>
                    Aichach, Germany 86573
                  </address>
                  <a href={"tel:+33755531479"}>+33 75 553-1479</a><br/>
                  <a href={"tel:+4930870780385"}>+49 30 87 078-0385</a><br/>
                  <br/>
                  <a href="mailto:info@euintlrealty.com">info@euintlrealty.com</a>
                </article>
              </div>
              <div className="col-md-3 col-sm-3">
                <article>
                  <h3>Useful Links</h3>
                  <ul className="list-unstyled list-links">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/properties">All Properties</Link></li>
                    <li><Link to="/faqs">Frequently Asked Questions</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="/contact">Terms & Conditions</Link></li>
                  </ul>
                </article>
              </div>
            </div>
          </div>
        </aside>
        <aside id="footer-thumbnails" className="footer-thumbnails"/>
        <aside id="footer-copyright">
          <div className="container">
            <span>Copyright © 2007. All Rights Reserved.</span>
            <span className="pull-right">
                <Link to="#" className="roll" title={"Go to top"}
                      onClick={scrollToTop}>
                  <i className="fa fa-arrow-up"/>
                </Link>
              </span>
          </div>
        </aside>
      </div>
    </footer>
  );
}

export default Footer;